"use client"

import styled from "@emotion/styled"
import { CustomBreadcrumbs } from "ui"
import Container from "ui/Container"
import { BreadCrumbs } from "utils"

const StyledBreadcrumbsContainer = styled.div`
  padding-top: 32px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 48px;
  }
`

export default function Breadcrumbs({
  breadCrumbs,
}: {
  breadCrumbs: BreadCrumbs
}) {
  return (
    <Container paddingMobile={true}>
      <StyledBreadcrumbsContainer>
        <CustomBreadcrumbs breadcrumbs={breadCrumbs} />
      </StyledBreadcrumbsContainer>
    </Container>
  )
}
